import * as React from "react";
import classnames from "classnames";
import { Text } from "@grandvisionhq/elements";
import { Icon } from "@grandvisionhq/icons";
/* empty css               */
const SignInBox = ({ className, labels, signInUrl, ...rest }) => /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames(className, "sign-in-box") }, /* @__PURE__ */ React.createElement(Icon, { name: "user", width: 56 }), /* @__PURE__ */ React.createElement("div", { className: "sign-in-box__text" }, /* @__PURE__ */ React.createElement(Text, null, labels.haveAnAccount), /* @__PURE__ */ React.createElement(Text, null, /* @__PURE__ */ React.createElement("a", { className: "sign-in-box__link", href: signInUrl }, labels.signIn), " ", labels.addInfo)));
export {
  SignInBox as default
};
//# sourceMappingURL=SignInBox.js.map
